<div [style.background-image]="'url(assets/images/404-Dark.svg)'" class="relative w-full h-screen bg-center bg-cover">
    <div class="absolute inset-0 dark:bg-opacity-50 bg-opacity-50"></div>
    <div class="relative z-10 flex flex-col items-center justify-center h-full px-4">
        <span class="icon-lock scale-[2.0] mb-2"></span>
        <h1 class="text-4xl font-bold mb-4">{{ 'unauthorized.title' | translate }}</h1>
        @if (management()) {
            <p class="text-lg text-center">{{ 'unauthorized.information-management' | translate }}</p>
        } @else {
            <p class="text-lg text-center">{{ 'unauthorized.information-customer' | translate }}</p>
        }
        <p class="text-lg mb-8 text-center">{{ 'unauthorized.advice' | translate }}</p>
        <div class="flex space-x-4 gap-2">
            <a
                class="btn btn-primary"
                [href]="'unauthorized.mail-to' | translate"
            >
                <i aria-hidden="true" class="icon element-help"></i>
                {{ 'unauthorized.support' | translate }}
            </a>
        </div>
    </div>
</div>
